"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _reactI18next = require("react-i18next");
var _image = _interopRequireDefault(require("../../helper/image"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => ({
  item: {
    aspectRatio: "612 / 214",
    display: "block",
    position: "relative",
    "&::before": {
      background: "rgba(45, 52, 62, 0.4)",
      bottom: 0,
      content: "''",
      left: 0,
      position: "absolute",
      right: 0,
      top: 0,
      zIndex: theme.zIndex.image.overlay
    }
  },
  image: {
    display: "block",
    objectFit: "cover",
    minHeight: "130px !important",
    zIndex: theme.zIndex.image.default
  },
  title: {
    alignItems: "center",
    bottom: theme.spacing(2.5),
    color: theme.palette.common.white,
    display: "flex",
    flexDirection: "column",
    fontWeight: 700,
    fontSize: "clamp(18px, 2vw, 28px)",
    justifyContent: "center",
    left: theme.spacing(2.5),
    margin: 0,
    position: "absolute",
    right: theme.spacing(2.5),
    textAlign: "center",
    textTransform: "uppercase",
    top: theme.spacing(2.5),
    zIndex: theme.zIndex.image.content
  }
}));
const ImageTeaser = _ref => {
  let {
    id,
    image,
    title
  } = _ref;
  const {
    REACT_APP_PATH
  } = process.env;
  const {
    i18n
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    className: css.item,
    to: "/".concat(i18n.language, "/activities/").concat(id)
  }, /*#__PURE__*/_react.default.createElement(_image.default, {
    itemStyle: css.image,
    filename: (image === null || image === void 0 ? void 0 : image.filename) && ((image === null || image === void 0 ? void 0 : image.filename.charAt(0)) === "/" ? REACT_APP_PATH : "") + (image === null || image === void 0 ? void 0 : image.filename),
    height: image === null || image === void 0 ? void 0 : image.height,
    width: image === null || image === void 0 ? void 0 : image.width,
    alt: ""
  }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: css.title,
    component: "p",
    dangerouslySetInnerHTML: {
      __html: title
    },
    variant: "h1"
  }));
};
var _default = exports.default = ImageTeaser;